/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Notebook
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define('notebook/ReportingWidget', [ 'notebook/bundles/reporting.min' ], entry => entry.ReportingWidget);

define('notebook/bundles/reporting.bridge', () => {});
